import { useCallback, useReducer } from 'react';

const LIMIT = 100;

function reducer(state, action) {
  switch (action.t) {
    case 'set':
      return {
        ...state,
        past: action.record === false ? state.past : [...state.past, state.present].slice(-LIMIT),
        present: action.model,
        future: action.record === false ? state.future : [],
        dirty: true,
      };
    case 'load':
      return { past: [], present: action.model, future: [], selectedId: null, dirty: false };
    case 'undo':
      if (!state.past.length) return state;
      return {
        ...state,
        past: state.past.slice(0, -1),
        present: state.past[state.past.length - 1],
        future: [state.present, ...state.future],
        dirty: true,
      };
    case 'redo':
      if (!state.future.length) return state;
      return {
        ...state,
        past: [...state.past, state.present],
        present: state.future[0],
        future: state.future.slice(1),
        dirty: true,
      };
    case 'patch':
      return {
        ...state,
        past: action.record === false ? state.past : [...state.past, state.present].slice(-LIMIT),
        present: {
          ...state.present,
          elements: state.present.elements.map((el) => (el.id === action.id ? { ...el, ...action.patch } : el)),
        },
        future: action.record === false ? state.future : [],
        dirty: true,
      };
    case 'select':
      return { ...state, selectedId: action.id };
    case 'saved':
      return { ...state, dirty: false };
    default:
      return state;
  }
}

export function useEditorEtiqueta(initial) {
  const [state, dispatch] = useReducer(reducer, {
    past: [],
    present: initial,
    future: [],
    selectedId: null,
    dirty: false,
  });

  const setModel = useCallback((model, record = true) => dispatch({ t: 'set', model, record }), []);
  const updateElement = useCallback((id, patch) => dispatch({ t: 'patch', id, patch }), []);

  return {
    model: state.present,
    selectedId: state.selectedId,
    selected: state.present.elements.find((el) => el.id === state.selectedId) || null,
    dirty: state.dirty,
    canUndo: state.past.length > 0,
    canRedo: state.future.length > 0,
    setModel,
    updateElement,
    undo: () => dispatch({ t: 'undo' }),
    redo: () => dispatch({ t: 'redo' }),
    select: (id) => dispatch({ t: 'select', id }),
    markSaved: () => dispatch({ t: 'saved' }),
  };
}
